module.exports = __webpack_public_path__ + "media/images/vp/sample.taskimagethumb-a80cdcc4540fc2b6db1162f7eb40d0bf.png";